/**
 * Logger utility to avoid client side browser log in Production
 *
 * - Development/Preview: All log levels enabled
 * - Production: Only errors are logged. Use direct console log if you want production log.
 */

import { IS_PROD } from '@/util/constants';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noOperation = () => {};
const isProdClient = IS_PROD && typeof window !== 'undefined';

// Bind console methods to preserve stack traces
export const logger = {
  log: isProdClient ? noOperation : console.log.bind(console),
  debug: isProdClient ? noOperation : console.debug.bind(console),
  info: isProdClient ? noOperation : console.info.bind(console),
  warn: isProdClient ? noOperation : console.warn.bind(console),
  error: console.error.bind(console), // Always log errors
};
